module.exports = __webpack_public_path__ + "static/media/center_04.95819e7c.jpg";